export default __webpack_public_path__ + "78762c62bb4521ee2a3490ba30a0bfcd.png";